module.exports = __webpack_public_path__ + "static/media/selected_myprofile.9bedce6b.png";